import { traceHandle } from '../../tracing'
import { withGlobalOptions } from '../../types'
import { createAddress } from './create'
import { removeAddress } from './remove'
import { setDefaultAddress } from './set-default'
import { updateAddress } from './update'

const addressAttributes = { 'shopify.api': 'storefront', 'shopify.operation': 'customer' } as const

export const addressHandles = withGlobalOptions({
  create: traceHandle('shopify.storefront.customer.mutate', addressAttributes, createAddress),
  remove: traceHandle('shopify.storefront.customer.mutate', addressAttributes, removeAddress),
  update: traceHandle('shopify.storefront.customer.mutate', addressAttributes, updateAddress),
  setDefault: traceHandle(
    'shopify.storefront.customer.mutate',
    addressAttributes,
    setDefaultAddress,
  ),
})
